angular.module('bribac.interceptors.apiAuth', [
  'bribac.values',
  'bribac.services.authStorage'
])

  .config(function(
    $httpProvider
  ) {
    $httpProvider.interceptors.push('apiAuthInterceptor')
  })

  .factory('apiAuthInterceptor', function(
    $location,
    $q,
    API_BASE_URL,
    authStorage
  ) {
    return {

      request: function(config) {
        if (config.url.indexOf(API_BASE_URL) === 0) {
          var auth = authStorage.getTab()

          if (auth) {
            config.headers.Authorization = auth.token_type + ' ' + auth.access_token
          }
        }

        return config
      },

      responseError: function(response) {
        switch (response.status) {
          case 401: // UNAUTHORIZED
            authStorage.clear()
            $location.path('/login')
            break

          // no default
        }

        return $q.reject(response)
      }

    }
  })
